import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
const testimonials = [{
  name: 'Valentina M.',
  location: 'Buenos Aires',
  avatar: 'https://cdn.magicpatterns.com/uploads/kZ7AgHiB4nPdAkGpxmJwxd/testimonio_1_rebajada.webp',
  quote: 'Llevaba meses despertándome a las 3 de la mañana con el corazón acelerado. A la cuarta noche del protocolo dormí de un tirón hasta las 7. No lo podía creer.'
}, {
  name: 'Carolina R.',
  location: 'Córdoba',
  avatar: 'https://cdn.magicpatterns.com/uploads/nMRR9TNT44g97j2CFMCuSw/testimonio_2_rebajada.webp',
  quote: 'Probé mil cosas para dormir y nada me funcionaba. Esto fue diferente desde el primer día. Sin pastillas, sin apps, sin complicaciones.'
}, {
  name: 'Luciana P.',
  location: 'Rosario',
  avatar: 'https://cdn.magicpatterns.com/uploads/vyBa34RsZ9zo9tBSxhypRx/testimonio_3_rebajada.webp',
  quote: 'Pensé que era ansiedad crónica y que iba a ser así para siempre. Después de la primera semana empecé a acostarme sin miedo a la noche.'
}];
export function TestimonialsSection() {
  return <section className="py-16 md:py-24 px-4 bg-card/30 border-y border-white/5 relative overflow-hidden" data-id="element-108">
      <div className="absolute top-1/2 right-0 w-72 h-72 bg-warm/5 rounded-full blur-[80px] -z-10 pointer-events-none" data-id="element-109"></div>

      <div className="max-w-5xl mx-auto" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-111">
          <span className="text-sm font-bold tracking-widest text-warm uppercase mb-3 block" data-id="element-112">
            Historias Reales
          </span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-main" data-id="element-113">
            Lo que dicen quienes ya lo probaron
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8" data-id="element-114">
          {testimonials.map((t, i) => <motion.div key={t.name} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.15
        }} className="bg-base/80 backdrop-blur-sm border border-warm/15 rounded-2xl p-6 md:p-8 flex flex-col relative" data-id="element-115">
              <QuoteIcon size={28} className="text-warm/20 absolute top-5 right-5" strokeWidth={1.5} data-id="element-116" />

              <div className="flex items-center gap-1 mb-5" data-id="element-117">
                {Array.from({
              length: 5
            }).map((_, idx) => <StarIcon key={idx} size={16} className="text-warm fill-warm" data-id="element-118" />)}
              </div>

              <p className="text-muted text-base leading-relaxed flex-1 mb-6" data-id="element-119">
                "{t.quote}"
              </p>

              <div className="flex items-center gap-3 pt-5 border-t border-white/10" data-id="element-120">
                <img src={t.avatar} alt={t.name} className="w-11 h-11 rounded-full object-cover border-2 border-warm/30" data-id="element-121" />
                <div data-id="element-122">
                  <p className="text-main font-semibold text-sm" data-id="element-123">{t.name}</p>
                  <p className="text-muted/70 text-xs" data-id="element-124">{t.location}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}